<div *ngIf="loginRequired || (!isLoading && !errorOccured); else noApp">
  <colmec-navbar (navbarHeight)="setContainerMarginTop($event)"></colmec-navbar>
  <div class="container pt-5 main" [ngStyle]="containerStyles">
    <router-outlet></router-outlet>
  </div>
  <div class="footer mt-3" *ngIf="!router.isActive('checkout', true) && !loginRequired">
    <div class="container">
      <div class="row">
        <div class="col-2 icon-question">
          <i class="far fa-question-circle"></i>
        </div>
        <div class="col-10">
          <div class="footer-title">
            <span translate>MISSING_SOMETHING_SPECIFIC</span><br />
            <span translate>GET_IN_TOUCH</span><br />
            <span class="orange" translate>OPORTUNITY_TO_PRODUCE</span>
          </div>
          <div class="row mt-3">
            <div class="col-4">
              <div class="col-f-title">Reception</div>
              <div class="col-f-content">
                <span translate>PHONE</span>: 011-20 20 00<br />
                <span translate>EMAIL</span>: info&#64;colmec.se<br />
                <span translate>OPEN_HOURS_WEEK</span> 07:30-16:30<br />
              </div>
            </div>
            <div class="col-4">
              <div class="col-f-title">Kundservice</div>
              <div class="col-f-content">
                <span translate>PHONE</span>: 011-20 20 20<br />
                <span translate>EMAIL</span>: order&#64;colmec.se<br />
                <span translate>OPEN_HOURS_WEEK</span> 08:00-16:00<br />
                <span translate>FAQ</span>
              </div>
            </div>
            <div class="col-4">
              <div class="col-f-title" translate>FOLLOW_US</div>
              <div class="col-f-content">
                <i class="fab fa-instagram"></i><a href="https://www.instagram.com/colmec/" target="_blank">Instagram</a
                ><br />
                <i class="fab fa-facebook-f"></i
                ><a href="https://www.facebook.com/colmecab/" target="_blank">Facebook</a><br />
                <i class="fab fa-linkedin-in"></i
                ><a href="https://www.linkedin.com/company/colmec-ab/" target="_blank">LinkedIn</a><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noApp>
  <div class="wrapper d-flex align-items-center justify-content-center m-5">
    <div *ngIf="isLoading && !errorOccured">
      <i class="fa fa-spinner fa-spin fa-7x"></i>
    </div>
    <div *ngIf="errorOccured">
      <h1 class="text-center">An error occured, please log out and contact your supplier</h1>
      <div class="d-flex justify-content-center">
        <button class="btn btn-primary" (click)="logout()" translate>LOGOUT</button>
      </div>
    </div>
  </div>
</ng-template>
<lib-gung-notification></lib-gung-notification>
